import React, {
  useEffect,
  useState,
  useContext
} from 'react';
import {
  Box,
  Container,
  Button,
  makeStyles,
  Typography
} from '@material-ui/core';
import { NavLink as RouterLink, Navigate } from 'react-router-dom';
import Page from 'src/components/Page';
import Tabelas from '../../shared/component/UIElements/Tabelas';
import { useHttpClient } from '../../hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import ErrorMessage from '../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../shared/component/UIElements/LoadingSpinner';
import Modal from '../../shared/component/Modal';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  button: {
    color: 'white',
    paddingRight: '40px',
    paddingLeft: '40px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px'
  },
  nome: {
    marginBottom: '15px',
  }
}));

const Acervos = () => {
  const auth = useContext(AuthContext);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const classes = useStyles();
  const [acervos, setAcervos] = useState([]);
  const [query, setQuery] = useState(null);
  const [navegar, setNavegar] = useState(false);
  const [remover, setRemover] = useState(false);
  const [verMapa, setVerMapa] = useState(null);

  const handleEdit = (qual) => {
    setNavegar(`acervos/${qual}`);
  };
  const fecharDeletar = () => {
    setRemover(false);
  };
  const abrirDeletar = (qual) => {
    setRemover(qual);
  };
  const handleDelete = async () => {
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/acervos/${remover}`,
        'DELETE',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(responseData);
      if (responseData.sucesso) {
        setAcervos((prevState) => {
          const data = [...prevState.filter((item) => item.id !== remover)];
          setRemover(false);
          return data;
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleVisibility = async (id) => {
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/acervos/visibilidade/${id}`,
        'POST',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );

      if (responseData.sucesso) {
        setAcervos((prevState) => {
          const data = prevState.map((acervo) => {
            if (acervo.id === id) {
              acervo.exibir.conteudo = !acervo.exibir.conteudo;
            }
            return acervo;
          });
          return data;
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleBusca = (event) => {
    const searchLower = String(event.target.value).toLowerCase();
    if (String(searchLower).trim().length > 0) {
      const filtradas = acervos.filter((acerv) => String(acerv.nome.conteudo).toLowerCase().includes(searchLower) || String(acerv.numero.conteudo).toLowerCase().includes(searchLower));
      console.log(filtradas);
      setQuery(filtradas);
    } else {
      setQuery(null);
    }
  };
  useEffect(() => {
    const fetchAcervos = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/acervos/`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setAcervos(() => {
          const data = [...responseData.data.map((acervo) => ({
            id: acervo._id,
            nome: {
              conteudo: acervo.nome,
              avatar: acervo.destaque !== undefined ? `${process.env.REACT_APP_BACKEND_IMG}${acervo.destaque.caminho}` : '',
              tipo: 'avatar'
            },
            numero: {
              conteudo: acervo.num_inventario,
              tipo: 'text'
            },
            criacao: {
              conteudo: new Date(acervo.createdDate).toLocaleString(),
              tipo: 'data'
            },
            estado: {
              conteudo: acervo.status,
              tipo: 'text'
            },
            situacao: {
              conteudo: acervo.situacao !== undefined ? acervo.situacao.nome : '',
              tipo: 'texto'
            },
            mapa: {
              conteudo: 'Ver no mapa',
              tipo: 'button',
              dica: 'Ver no Mapa',
              sala: acervo.sala
            },
            exibir: {
              conteudo: acervo.exibicao,
              tipo: 'exibir',
              pode: responseData.editar
            },
            edit: responseData.editar,
            delete: responseData.deletar
          }))];
          return data;
        });
      } catch (err) {
        console.log(err);
      }
    };
    fetchAcervos();
  }, [sendRequest, auth]);
  const verMapaOpen = (id) => {
    const mapa = acervos.filter((acerv) => acerv.id === id);
    if (mapa.length > 0) {
      setVerMapa(mapa[0]);
    }
  };
  const LinkBehavior = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/app/acervos/novo" exact {...props} />
  ));
  const LinkBehaviorSituacoes = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/app/situacoes/" exact {...props} />
  ));
  const LinkBehaviorClassificacoes = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/app/classificacoes/" exact {...props} />
  ));
  const LinkBehaviorProcedencias = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/app/procedencias/" exact {...props} />
  ));
  if (navegar) {
    return <Navigate to={`/app/${navegar}`} />;
  }
  return (
    <Page
      className={classes.root}
      title="Itens de Acervo"
    >
      <Container maxWidth={false}>
        <Box mt={3}>
          <Box
            display="flex"
            justifyContent="flex-start"
            pb={4}
          >
            {(auth.userPermission.permissoes.includes('create_acervos') || auth.userPermission.nome === 'Gestor do Sistema') && (
              <Button
                color="secondary"
                variant="contained"
                component={LinkBehavior}
                className={classes.button}
              >
                Cadastrar novo Item
              </Button>
            )}
            {(auth.userPermission.permissoes.includes('create_situacoes') || auth.userPermission.nome === 'Gestor do Sistema') && (
              <Button
                color="primary"
                variant="contained"
                component={LinkBehaviorSituacoes}
                className={classes.button}
                style={{ marginLeft: '15px' }}
              >
                Lista de Situações
              </Button>
            )}
            {(auth.userPermission.permissoes.includes('all_admin') || auth.userPermission.nome === 'Gestor do Sistema') && (
              <Button
                color="primary"
                variant="contained"
                component={LinkBehaviorClassificacoes}
                className={classes.button}
                style={{ marginLeft: '15px' }}
              >
                Lista de Classificações
              </Button>
            )}
            {(auth.userPermission.permissoes.includes('all_admin') || auth.userPermission.nome === 'Gestor do Sistema') && (
              <Button
                color="primary"
                variant="contained"
                component={LinkBehaviorProcedencias}
                className={classes.button}
                style={{ marginLeft: '15px' }}
              >
                Lista de Procedências
              </Button>
            )}
          </Box>
          {isLoading && <LoadingSpinner asOverlay />}
          <Tabelas
            data={query !== null ? query : acervos}
            estrutura={[
              { id: 'nome', tipo: 'avatar', nome: 'Nome' },
              { id: 'numero', tipo: 'texto', nome: 'Número do Inventário' },
              { id: 'criacao', tipo: 'data', nome: 'Data de Cadastro' },
              { id: 'estado', tipo: 'texto', nome: 'Estado' },
              { id: 'situacao', tipo: 'texto', nome: 'Situação' },
              { id: 'mapa', tipo: 'button', nome: 'Ver no Mapa' },
              { id: 'exibir', tipo: 'exibir', nome: 'Exibir no Site' },
              { id: 'acoes', tipo: 'acoes', nome: 'Ações' },
            ]}
            button={verMapaOpen}
            edit={handleEdit}
            remove={abrirDeletar}
            busca={handleBusca}
            exibir={handleVisibility}
            placeholder="Pesquisar item do acervo"
          />
          <ErrorMessage error={error} onClear={clearError} />
        </Box>
      </Container>
      <Modal
        open={remover}
        close={fecharDeletar}
        title="Deseja realmente remover este item do acervo?"
      >
        <Button
          color="primary"
          variant="contained"
          style={{ marginRight: '15px' }}
          onClick={handleDelete}
        >
          Remover Item
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={fecharDeletar}
        >
          Cancelar
        </Button>
      </Modal>
      <Modal
        open={Boolean(verMapa)}
        close={() => setVerMapa(null)}
        title="Sala do Item no Acervo"
      >
        {verMapa !== null && (
          <>
            <Typography
              color="textPrimary"
              align="left"
              variant="h3"
              className={classes.nome}
            >
              {`Sala: ${verMapa.mapa.sala.nome}`}
            </Typography>
            <img src={`${process.env.REACT_APP_BACKEND_IMG}${verMapa.mapa.sala.imagem.caminho}`} alt={verMapa.mapa.sala.imagem.original} />
          </>
        )}
      </Modal>
    </Page>
  );
};

export default Acervos;
